import { render, staticRenderFns } from "./InitialDate.vue?vue&type=template&id=d23ede60"
import script from "./InitialDate.vue?vue&type=script&lang=js"
export * from "./InitialDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports